export default (theme) => ({
  root: {
    '& svg path': {
      transition: 'ease fill 0.4s',
    },
    height: '100%',
    paddingBottom: 0,
  },

  sectionList: {
    minWidth: '50%',
    flexShrink: 1,
    flexGrow: 1,
    marginLeft: -4,
    marginTop: 8,
  },

  keyLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px',
    borderBottom: `1px solid ${theme.palette.graphs.separatorLine}`,
    color: 'rgb(89, 97, 104)',
    fontSize: 14,
    transition: 'ease opacity 0.4s',

    '& span': {
      marginLeft: 'auto',
      paddingLeft: 20,
    },

    '&:last-child': {
      borderBottom: 'none',
    },
  },

  keyDot: {
    position: 'relative',
    marginRight: 8,
    width: 10,
    height: 10,
    borderRadius: '50%',
    flexShrink: 0,
    display: 'inline-block',
    verticalAlign: 'center',
  },

  graphContainer: {
    height: 250,
    maxHeight: 350,
    marginLeft: 24,
    flexShrink: 1,
  },

  graph: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: 350,
    flexGrow: 1,
    flexShrink: 1,
  },
});
